// extracted by css-extract-rspack-plugin
export default {"title":"title-rzES7W","titleContainer":"titleContainer-HW4i57"};